// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"00c59e0a","453":"03346f77","455":"9bd96a90"}[chunkId] + ".chunk.js";
};